import React from 'react';
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const FeaturesSection = () => {
  const { t } = useTranslation("translation");

  return (
    <section className="features-benefits-section">
      {/* Top Section */}
      <div className="guest-container">
        <h2 className="features-main-title">
          {t("features.mainTitle")}
        </h2>

        <div className="features-grid">
          {/* Feature 1 */}
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <div className="feature-icon icon-blue">
                <i className="bi bi-file-earmark-text"></i>
              </div>
            </div>
            <div>
              <h3 className="feature-title">{t("features.feature1Title")}</h3>
              <p className="feature-description">
                {t("features.feature1Desc")}
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <div className="feature-icon icon-blue">
                <i className="bi bi-pen"></i>
              </div>
            </div>
            <div>
              <h3 className="feature-title">{t("features.feature2Title")}</h3>
              <p className="feature-description">
                {t("features.feature2Desc")}
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="feature-card">
            <div className="feature-icon-wrapper">
              <div className="feature-icon icon-blue">
                <i className="bi bi-shield-check"></i>
              </div>
            </div>
            <div>
              <h3 className="feature-title">{t("features.feature3Title")}</h3>
              <p className="feature-description">
                {t("features.feature3Desc")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom AI Banner */}
      <div className="ai-banner-section">
        <div className="ai-banner-content">
          <div className="badge-ai text-white fs-3 mb-2">
            <i className="bi bi-stars"></i> {t("features.aiPlatformBadge")}
          </div>

          <h2 className="ai-banner-title">
            <span className="title-highlight">
              {t("features.aiBannerTitle")}
            </span>
          </h2>

          <p className="ai-banner-description">
            {t("features.aiBannerDesc")}
          </p>

          <NavLink to="/product" className="btn-learn-more">
            {t("features.learnMoreBtn")}
            <i className="bi bi-arrow-right"></i>
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
